// Cache for solution score responses, keyed by UUID
// This prevents duplicate scoring API calls for the same solution
const scoreCache = new Map();

// Anyone waiting for a score they did not fetch themselves. A solution's score is fetched ONCE -- by whichever
// card gets there first -- and other views of the same solution read it out of here rather than asking again,
// so they need to know when it lands. A plain Map cannot say.
const subscribers = new Set();

export const getFromCache = (uuid) => scoreCache.get(uuid);
export const setInCache = (uuid, data) => {
  scoreCache.set(uuid, data);
  subscribers.forEach((subscriber) => subscriber(uuid, data));
};
export const hasInCache = (uuid) => scoreCache.has(uuid);
// Emptying the cache tells the subscribers too, with a null score: a view that settled on a cached answer has
// to be able to notice it is gone, or it would go on displaying a score nothing backs any more.
export const clearCache = () => {
  const cleared = [...scoreCache.keys()];
  scoreCache.clear();
  cleared.forEach((uuid) => subscribers.forEach((subscriber) => subscriber(uuid, null)));
};

// Watch for scores arriving. Returns the unsubscribe, so a caller can hand it straight back from a useEffect.
// Already-cached scores do NOT replay -- check hasInCache first; a subscriber only hears about later writes.
export const subscribeToCache = (subscriber) => {
  subscribers.add(subscriber);
  return () => subscribers.delete(subscriber);
};
